module.exports = __webpack_public_path__ + "img/0010.08f72e6a.png";